export default "__VITE_ASSET__DxSZOrUe__"